export default {"src":"/_next/static/media/GOAU.1f211ac3.svg","height":18,"width":18};